import './Header.less';
import {Drawer, Layout, Menu} from 'antd';
import {Link, useLocation, useNavigate} from 'react-router';
import main_logo from '../../../assets/logo/mainLogo.png';
import {useEffect, useMemo, useState} from 'react';
import {IRouteProps} from '../../../utils/types';
import {useSelector} from 'react-redux';
import {useMediaQuery} from 'react-responsive';
import {List, X} from '@phosphor-icons/react';
import menuIcon from '../../../assets/icons/menuIcon.png';

const AppHeader: React.FC = () => {
	const {Content} = Layout;
	const pages: any = useSelector((state: any) => state.routes.data);
	const isMobile = useMediaQuery({maxWidth: 865});

	const navigate = useNavigate();
	const location = useLocation();
	const choosenPage = location.pathname;
	const [menu, setMenu] = useState(false);

	const showDrawer = () => {
		setMenu(true);
	};
	useEffect(() => {
		setMenu(false);

		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	}, [location.pathname]);
	const menuItems = useMemo(() => {
		// @ts-ignore
		return pages
			.filter((el: IRouteProps) => el.navBar)
			.map((el: IRouteProps) => ({
				label: el.label,
				key: el.path,
				disabled: el.disabled,
				path: el.path,
				children:
					el.subMenu &&
					el.subMenu.map((subel: any) => ({
						...subel,
						onClick: () => {
							choosenPage !== subel.path && navigate(subel.path);
						},
						key: subel.path,
						path: subel.path
					})),
				onClick: () => {
					choosenPage !== el.path && !el.subMenu && el.path && navigate(el.path);
				}
			}));
	}, [pages, navigate, choosenPage]);

	return (
		<main className="nav_main">
			<Content className="navBar_content">
				<div className="logo_block">
					<Link to={'/'}>
						<img src={main_logo} alt="company_logo" className="main_logo" />
					</Link>
				</div>
				{!isMobile && (
					<div className="nav-list">
						<Menu
							onClick={() => {
								window.scrollTo({top: 0, behavior: 'smooth'});
							}}
							className="menu"
							items={menuItems}
							mode="horizontal"
							disabledOverflow
							defaultSelectedKeys={[choosenPage]}
							selectedKeys={[choosenPage]}
						/>
					</div>
				)}

				{isMobile && (
					<Drawer
						className="drawer"
						placement="right"
						onClose={() => setMenu(false)}
						open={menu}
						width={250}
						key="right">
						<div className="drawer-container">
							<Menu
								onClick={() => {
									window.scrollTo({top: 0, behavior: 'smooth'});
								}}
								style={{borderInlineEnd: 0}}
								className="menu"
								items={[
									...menuItems,
									{
										label: <Link to={'/contact-us'}>Contact us</Link>,
										key: '/contact-us'
									}
								]}
								mode="vertical"
								disabledOverflow
								defaultSelectedKeys={[choosenPage]}
								selectedKeys={[choosenPage]}
							/>
						</div>
					</Drawer>
				)}

				<div className="nav_contact_us_button_block">
					<Link to={'/contact-us'}>
						<button className="contact_us_nav_button">Contact us</button>
					</Link>
					{isMobile && (
						<span onClick={showDrawer}>
							<List size={32} color="white" />
						</span>
					)}
				</div>

				<div></div>
			</Content>
		</main>
	);
};

export default AppHeader;
